
const nameList = [
    {
        entityField: "storeName",
        showField: "门店名称",
        fieldWeight: 130,
        fieldType: "string",

    },
    {
        entityField: "deskCode",
        showField: "收款台编码",
        fieldWeight: 130,
        fieldType: "string",

    },
    {
        entityField: "deskState",
        showField: "收款台状态",
        fieldWeight: 130,
        fieldType: "string",

    },
    {
        entityField: "deskType",
        showField: "收款台类型",
        fieldWeight: 130,
        fieldType: "string",

    },
    {
        entityField: "salerName",
        showField: "默认销售员",
        fieldWeight: 130,
        fieldType: "string",
    },
    {
        entityField: "isSmall",
        showField: "是否允许抹零",
        fieldWeight: 130,
        fieldType: "string",

    },
]


const deskBookList = [

    {
        entityField: "abookCode",
        showField: "账簿编号",
        fieldWeight: 70,
        fieldType: "string",

    },
    {
        entityField: "abookName",
        showField: "账簿名称",
        fieldWeight: 130,
        fieldType: "string",

    },

]



const  searchList= [
    {
        showField: "门店名称",
        entityField: "storeName",
        isShow: 1,
        fieldType: "search",
        searchId: 293839281728,
        formatterContent: null,
        isRift: null,
        riftField: null,
        setField: "storeName,storeId",
        fieldWeight: 120,
    },
  
    {
        showField: "收款台类型",
        entityField: "deskType",
        isShow: 1,
        fieldType: "select",
        searchId: null,
        formatterContent: [
            {
                key: "收款",
                value: '收款',
            },
            {
                key: "划价",
                value: "划价",
            },
        ],
        isRift: null,
        riftField: null,
        setField: null,
        fieldWeight: 120,
    },
    {
        showField: "销售员",
        entityField: "salesPersonName",
        isShow: 1,
        fieldType: "search",
        searchId: 293839280003,
        formatterContent: null,
        isRift: null,
        riftField: null,
        setField: "salesPersonName,salesPersonId",
        fieldWeight: 120,
    },
    {
        showField: "是否允许抹零",
        entityField: "isSmall",
        isShow: 1,
        fieldType: "select",
        searchId: null,
        formatterContent: [
            {
                key: "是",
                value: 1,
            },
            {
                key: "否",
                value: 0,
            },
        ],
        isRift: null,
        riftField: null,
        setField: null,
        fieldWeight: 120,
    },
]
 
export {nameList, deskBookList,searchList}